'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var CrossIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="2" y1="2" x2="16" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="2" y1="16" x2="16" y2="2"/>';
    case 'medium':
      return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="3" x2="29" y2="29"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="29" x2="29" y2="3"/>';
    case 'large':
      return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.5" y1="4.5" x2="43.5" y2="43.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.5" y1="43.5" x2="43.5" y2="4.5"/>';
    }
  }
});

module.exports = CrossIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Cross.jsx
 **/